import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { CheckOutlineCircle } from '../../../Components/Icons/CheckOutlineCircle';
import { PRIMARY_BLUE } from '../../../Constants/Colors.constants';
import IMAGES from '../../../Constants/Images.constants';
import { Button, Typography } from '../../../UIKit';
import { makeStyles } from '~/UIKit/Style';

interface IOnboardingConfirmationSuccessProps {
  onStartClick: () => void;
}

const useStyles = makeStyles((theme) => ({
  onboardingConfirmationContent: {
    textAlign: 'center',
    maxWidth: 552,
    padding: '0 20px',
    [theme.breakpoints.down('md')]: {
      margin: 'auto',
    },
  },
  onboardingColumn: {
    overflowY: 'auto',
    flex: 1,
  },
  onboardingConfirmationTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    lineHeight: '27px',
    overflowWrap: 'break-word',
    margin: '0 auto 30px',
    maxWidth: 350,
  },
  onboardingConfirmationDesc: {
    fontSize: 16,
    marginBottom: 30,
    lineHeight: '27px',
    margin: '0 auto 30px',
    maxWidth: 310,
  },
  onboardingConfirmationConfirmButton: {
    width: 300,
    height: 50,
    fontSize: '1rem',
  },
  checkMark: {
    width: 50,
    height: 50,
    color: PRIMARY_BLUE,
    marginBottom: 30,
  },
  confirmationImage: {
    width: '100%',
    maxWidth: 571,
    marginTop: 70,
    float: 'right',
    padding: 0,
    [theme.breakpoints.down('md')]: {
      float: 'none',
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'block',
      padding: '0 15px',
    },
  },
}));

export const OnboardingConfirmationSuccess = ({
  onStartClick,
}: IOnboardingConfirmationSuccessProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className={classes.onboardingColumn}>
        <img src={IMAGES.ONBOARDING.confirmation} className={classes.confirmationImage} />
      </div>
      <div className={classes.onboardingColumn}>
        <div className={classes.onboardingConfirmationContent}>
          <CheckOutlineCircle className={classes.checkMark} />
          <Typography className={classes.onboardingConfirmationTitle}>
            <Trans i18nKey="onboarding.email.confirmed" />
          </Typography>
          <Typography className={classes.onboardingConfirmationDesc}>
            <Trans i18nKey="onboarding.email.confirmed.details" />
          </Typography>
          <Button
            className={classes.onboardingConfirmationConfirmButton}
            onClick={onStartClick}
            variant="contained"
            color="primary"
          >
            {t('onboarding.welcomemessage.button')}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};
